export default __webpack_public_path__ + "static/media/threedots.7e120c31.svg";